var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ribbon"},[_c('div',{staticClass:"container",class:{
      'has-container-padding': _vm.padding === 'default',
      'is-paddingless': _vm.padding === 'none'
    }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }